



































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import FileUpload from "vue-upload-component";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component ({
    components: {
      FileUpload
    }
  })
export default class PartnerLogoUpload extends Vue {
  $router: VueRouter;
  $validator: Validator;

  notifierStore = useNotifierStore();
  portalCustomizationStore = usePortalCustomizationStore();
  file = null;
  isSubmitting = false;
  accept = ".png,.svg";

  @Prop() partnerId: number;

  mounted () {
    this.portalCustomizationStore.getPartnerCustomLogo(this.partnerId);
    this.initialize();
  }

  @Watch("isLoaded")
  initialize () {
    if (this.portalCustomizationStore.partnerLogoSrc && this.$refs.logo) {
      (this.$refs.logo as any).src = this.portalCustomizationStore.partnerLogoSrc;
    }
  }

  fileLogoChange (file) {
    if (!file) return;
    this.file = (document.getElementById("logo-asset") as any).files[0];
    const f = new FileReader();
    f.onload = () => (this.$refs.logo as any).src = f.result;
    f.readAsDataURL(this.file);
  }

  get submitDisabled () {
    return this.isSubmitting;
  }

  submit () {
    if (!this.file) return;
    if (this.isSubmitting) return;

    this.isSubmitting = true;

    this.portalCustomizationStore.savePartnerCustomLogo({
      partnerId: this.partnerId,
      logoFile: this.file
    })
    .then(resp => {
      this.$nextTick(() => {
      this.notifierStore.setSuccess("partner support info saved", this.notifierStore.shortTimeout);
      this.isSubmitting = false;
      this.initialize();
      });
    })
    .catch(() => {
      this.isSubmitting = false;
      this.notifierStore.setDanger("Could not save partner logo", this.notifierStore.shortTimeout);
    });
  }
  deleteAsset (): void {
    this.isSubmitting = true;

    this.portalCustomizationStore.deletePartnerCustomLogo(this.partnerId)
        .then(resp => {
          this.$nextTick(() => {
            this.notifierStore.setSuccess("Partner asset deleted", this.notifierStore.shortTimeout);
            this.isSubmitting = false;
            this.initialize();
          });
        })
        .catch(() => {
          this.isSubmitting = false;
          this.notifierStore.setDanger("Could not delete partner asset", this.notifierStore.shortTimeout);
        });
  }
}
